import { useCallback, useMemo } from 'react'
import { parsedModules as modules } from 'core/common/utils/parsedModules'
import { TModule } from '../type'

const useSelectedModule = (visitedPath: string): TModule => {
  const validatePath = useCallback(
    item => {
      return item.prefix === visitedPath || item?.redirect_from === visitedPath
    },
    [visitedPath]
  )

  const module: TModule = useMemo(() => modules.find(validatePath), [validatePath])

  return module
}

export default useSelectedModule
